import React from 'react';

interface ToastProps {
  message: string;
  type?: 'info' | 'success' | 'error';
}

export const Toast: React.FC<ToastProps> = ({ message, type = 'info' }) => {
  const icon = type === 'success' ? '✓' : type === 'error' ? '✕' : 'ℹ';
  const bgColor = type === 'success' ? 'hsl(142, 76%, 36%)' : type === 'error' ? 'hsl(346, 84%, 61%)' : 'hsl(217, 33%, 12%)';

  return (
    <div className="toast-container">
      <div className="toast" style={{ backgroundColor: bgColor }}>
        <span style={{ fontWeight: 'bold' }}>{icon}</span>
        <span>{message}</span>
      </div>
    </div>
  );
};
